export default __webpack_public_path__ + "static/media/milegrid-logo-svg.090c4a2e.svg";